var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoClubWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 234,
    viewBox: "0 0 1920 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_11463_105412)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.443 159.114L905.41 109.537C1140.81 59.9607 1618.74 -39.1926 2093.11 43.435C2567.48 126.063 2877.64 263.863 3519.78 263.863C4161.92 263.863 4472.08 159.114 4707.48 109.537L4946.44 -92.9625L4946.44 853.186L4707.48 853.186C4472.08 853.186 3994.14 853.186 3519.78 853.186C3045.41 853.186 2567.48 853.186 2093.11 853.187C1618.74 853.187 1140.81 853.187 905.41 853.187L666.443 853.187L666.443 159.114Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2806 268.076L2567.03 218.5C2331.63 168.923 1853.7 69.7699 1379.33 152.398C904.966 235.025 594.807 372.825 -47.3338 372.825C-689.475 372.825 -999.634 268.076 -1235.03 218.499L-1474 16L-1474 962.149L-1235.03 962.149C-999.634 962.149 -521.7 962.149 -47.3338 962.149C427.033 962.149 904.966 962.149 1379.33 962.149C1853.7 962.149 2331.63 962.149 2567.03 962.149L2806 962.149L2806 268.076Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-874.661 213.434L-635.572 163.858C-400.051 114.281 78.1278 15.1277 552.738 97.7553C1027.35 180.383 1337.67 318.183 1980.14 318.183C2622.61 318.183 2932.93 213.434 3168.45 163.857L3407.54 -38.6422L3407.54 907.507L3168.45 907.507C2932.93 907.507 2454.75 907.507 1980.14 907.507C1505.53 907.507 1027.35 907.507 552.738 907.507C78.1278 907.507 -400.051 907.507 -635.572 907.507L-874.661 907.507L-874.661 213.434Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11463_105412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3563,
    height: 234,
    fill: "white",
    transform: "translate(-733)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoClubWave);
export default __webpack_public_path__ + "static/media/no-club-wave.2de5062dfe4b3a2bf40b1f2bbbb49ba7.svg";
export { ForwardRef as ReactComponent };